import styled from "styled-components";
import { CircleButton } from "_c/button";

export const Line = styled.div`
  position: relative;
`;

export const Name = styled.h1`
  font-size: 18px;
  @media (max-width: ${({ theme }) => theme.mobileBp}) {
    font-size: 14px;
  }
  font-weight: 500;
  margin: 0;
  color: var(--font-color-emp);
  // margin-right: 5px;
  // white-space: nowrap;
  padding: 5px 0;
`;
export const OnlineStatus = styled.span`
  --size: 8px;
  display: inline-block;
  background-color: ${({ isOnline, theme }) =>
    isOnline ? theme.color.positive : theme.color.negative};
  width: var(--size);
  height: var(--size);
  min-width: var(--size);
  min-height: var(--size);
  border-radius: 50%;
  margin-right: 6px;
`;
export const AttentionSign = styled.span`
  color: white;
  font-size: 21px;
  font-weight: 600;
  margin-top: -2px;
`;
export const ShareButton = styled(CircleButton)`
  padding-left: 2px;
  padding: 5px 0;
`;
export const LikeButton = styled(CircleButton)`
  padding: 5px 0;
  margin-right: 7px;
  :disabled {
    opacity: 0.3;
    cursor: auto;
  }
`;
